import React from "react";
import "./CommentTile.css";

const CommentTile = () => {
  return (
    <div className="comment-tile">
      <div className="comment-tile-content">
        <div className="avatar">
          <img
            src="./assets/team/Dhruv_Mohan-Passport.JPG" // Replace with the actual image URL
            alt="Casey Hudson"
          />
        </div>
        <div className="text">
          <p className="quote">
            "At Space.LABS, we believe technology is a force for transformation,
            pushing the boundaries of what’s possible to create advanced
            solutions that empower industries and shape the future. With
            precision, integrity, and bold thinking, we innovate with
            purpose—solving tomorrow’s challenges today.
            <br /> Our commitment to sustainability, security, and scalability
            ensures that every breakthrough leads to a smarter, more connected
            world. Collaboration, curiosity, and excellence drive us, because
            the future isn’t something we wait for—it’s something we build."
          </p>
          <p className="author">Dhruv Mohan, Founder & CEO</p>
        </div>
      </div>
    </div>
  );
};

export default CommentTile;
